import { NavLink } from 'react-router-dom';

import Button from '@mui/material/Button';
import ListItem from '@mui/material/ListItem';
import AppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';

import theme from '../../theme';


export const AppBarStyle = styled(AppBar)(props => {
  return {
    paddingRight: '38px',
    paddingLeft: '24px',
    boxShadow: `1px 1px 4px 1px ${theme.palette.grey.w100}`,
    // borderBottom: `1px solid ${theme.palette.grey.w200}`,
    backgroundColor: '#fff',
  }
})

export const ToolbarStyle = {
  minHeight: '60px',
  display: 'flex',
  padding: 0,
  justifyContent: 'space-between',
}

export const ProductNameStyle = {
  paddingLeft: '12px',
  color: theme.palette.secondary.main
}

export const UserPaperStyle = {
  borderRadius: '8px',
  boxShadow: `0px 2px 10px ${theme.palette.grey.w300}`
}

export const TopbarButton = styled(Button)(props => ({
  color: theme.palette.text.primary,
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '0.875rem',
  padding: '6px 14px',
  borderRadius: '8px',

  '&:hover': {
    backgroundColor: theme.palette.primary.w50,
  }
}))

export const StageListItem = styled(ListItem)(props => ({
  width: 'auto',
  color: props.color,
  marginRight: '16px',
  padding: '6px 12px',
  border: `1px solid ${props.color}`,
  borderRadius: '30px',
  fontSize: '0.875rem'
}))

export const SpanTxtStyle = styled('span')({
  color: theme.palette.primary.main
})